/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    banks: {
        menu: {
            index: 'Banks',
            create: 'New bank',
            list: 'Banks'
        },
        table_titles: {
            id: 'ID',
            name: 'Name',
            country: 'Country',
            is_active: 'Active',
            swift_bic: 'Swift BIC',
            show_on_home: 'Show on home',
            setting: 'Edit / Delete',
        },
        edit: 'Edit bank'
    },
    bank_accounts: {
        currency: 'Currency',
        payment_method: 'Payment Method',
        account_number: 'Account Number',
        edit_form: 'Bank account edit form',
    }
}
